import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import DatePicker from 'react-datepicker'
import { Form, InputGroup } from 'react-bootstrap'

import { CalendarIcon } from '@heroicons/react/24/outline'

import 'react-datepicker/dist/react-datepicker.css'
import './CustomDatePicker.scss'

const DatePickerComponent = ({
    allowFutureDates = true,
    dmode,
    selectedDate,
    setSelectedDate,
    placeholder = 'Select a Date',
    label,
    name = 'date',
    dir = 'ltr',
}) => {
    const { t } = useTranslation()

    const handleClearDate = (e) => {
        if (e.key === 'Backspace') {
            setSelectedDate(null, name)
        }
    }

    return (
        <>
            <Form.Group className="mb-2" dir={dir}>
                {label ? (
                    <Form.Label className="glo-label">{t(label)}</Form.Label>
                ) : (
                    <Form.Label
                        className="glo-label"
                        style={{ color: 'transparent' }}
                    >
                        *
                    </Form.Label>
                )}
                <InputGroup>
                    <div>
                        <DatePicker
                            placeholderText={t(placeholder)}
                            showYearDropdown
                            selected={selectedDate}
                            onChange={(date) => setSelectedDate(date, name)}
                            customInput={
                                <CustomInput
                                    onClearDate={handleClearDate}
                                    dir={dir}
                                    dmode={dmode}
                                />
                            }
                            maxDate={allowFutureDates ? null : new Date()}
                            dateFormat="dd/MM/yyyy"
                            popperPlacement="bottom-start"
                        />
                    </div>
                </InputGroup>
            </Form.Group>
        </>
    )
}

const CustomInput = forwardRef(
    ({ value, onClick, placeholder, dir, dmode, onClearDate }, ref) => {
        return (
            <div
                onClick={onClick}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                }}
            >
                <input
                    type="text"
                    value={value || ''}
                    onChange={() => {}} // Prevents input from being editable
                    onKeyDown={onClearDate}
                    ref={ref}
                    placeholder={placeholder}
                    className={`form-control date-input ${
                        dir === 'rtl' ? 'date-input-rtl' : 'date-input-ltr'
                    }  ${dmode && 'date-input-dark'}`}
                />
                <div
                    className={` ${
                        dmode ? 'icon-wrapper-dark' : 'icon-wrapper'
                    } ${
                        dir === 'rtl' ? 'icon-wrapper-rtl' : 'icon-wrapper-ltr'
                    } `}
                >
                    <CalendarIcon
                        style={{
                            height: 20,
                            width: 14,
                            color: dmode ? 'white' : '#828282',
                        }}
                    />
                </div>
            </div>
        )
    }
)

export default DatePickerComponent
